import { FC, useMemo, useState } from 'react'

import GameSearchAndSort from '../../../../../components/GameSearchAndSort/GameSearchAndSort'
import MultiGameSelector from '../../../../../components/MultiGameSelector/MultiGameSelector'
import { Game } from '../../../../../features/game/types/Game'
import { gameComparator } from '../../../../../features/implementation-examples/util/comparators'
import { bulkAssignMarketIso } from '../../helpers/bulkAssignHelpers'

// SaaS's games pickers rank games without a rank after the top 2000.
const unrankedRank = 2001

// Not one of `MultiGameSelector`'s orders, so it keeps the US order given here instead of the SaaS user's market.
const givenOrder = 'given'

type BulkAssignGamesFilterProps = {
  games: Game[]
  selectedGameIds: string[]
  loading?: boolean
  onChange: (gameIds: string[]) => void
}

export const BulkAssignGamesFilter: FC<BulkAssignGamesFilterProps> = ({ games, selectedGameIds, loading, onChange }) => {
  const [sortCriteria, setSortCriteria] = useState('sustained_grossing_rank')
  const options = useMemo(() => {
    const ranked = games.map((stored) => {
      const game = new Game(stored)
      game.sranks = { ...game.sranks, [bulkAssignMarketIso]: game.sranks?.[bulkAssignMarketIso] || unrankedRank }
      game.sdranks = { ...game.sdranks, [bulkAssignMarketIso]: game.sdranks?.[bulkAssignMarketIso] || unrankedRank }
      return game
    })
    return ranked.sort(gameComparator(bulkAssignMarketIso, sortCriteria))
  }, [games, sortCriteria])
  const selectedGames = useMemo(() => options.filter(({ id }) => selectedGameIds.includes(id)), [options, selectedGameIds])

  return (
    <>
      <GameSearchAndSort hideAutoComplete sortValue={sortCriteria} onChangeSort={setSortCriteria} onChangeSearch={() => {}} />
      <MultiGameSelector
        loading={loading}
        options={options}
        selectedGames={selectedGames}
        setSelectedGames={(picked) => onChange(picked.map(({ id }) => id))}
        onClear={() => onChange([])}
        sortCriteria={givenOrder}
        skipInitGameIds
      />
    </>
  )
}
